import left from './assets/landscape/left-layer-4.svg';
import right from './assets/landscape/left-layer-4.svg';
import './gameCard.css';

export const gameCard = { left, right };
